import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'
import { FormEvent, memo, ReactNode, type JSX } from 'react'
import { useTranslation } from 'react-i18next'
import AsyncActionButton from '../Button/AsyncActionButton'

interface Props {
  onCancel: () => void
  onConfirm: (event: FormEvent<HTMLFormElement>) => void
  title: string | ReactNode
  children?: ReactNode
  open: boolean
  disabled?: boolean
  isPending?: boolean
  isSuccess?: boolean
  isError?: boolean
}

const FormsDialog = ({
  onCancel,
  onConfirm,
  title,
  children,
  open,
  disabled = false,
  isPending: isLoading = false,
  isSuccess = false,
  isError = false,
}: Props): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Dialog onClose={onCancel} open={open} slotProps={{ paper: { component: 'form', onSubmit: onConfirm } }}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Stack direction="row-reverse">
          <AsyncActionButton
            type="submit"
            disabled={disabled}
            color="primary"
            isPending={isLoading}
            isSuccess={isSuccess}
            isError={isError}
          >
            {t('common.confirm')}
          </AsyncActionButton>
          <Button onClick={onCancel} color="inherit" disabled={isLoading}>
            {t('common.cancel')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}

export default memo(FormsDialog)
